import React from 'react';
import { Grid } from 'vindi-ds-components';
import SectionWithGrid from './section_with_grid';
import getCustomField from './custom_field';

function CustomFields({ title, customFields }) {
  return (
    <SectionWithGrid title={title}>
      {
        customFields.map((customField) => (
          <Grid item xs={12} md={12} key={customField.id}>
            {getCustomField(customField)}
          </Grid>
        ))
      }
    </SectionWithGrid>
  );
}

export default CustomFields;
